import "../Footer/Footer.scss";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { FiFacebook } from "react-icons/fi";
import logoimg from "../../assets/Home/main-log.svg";
import { FaLocationDot } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";
import { MdMailOutline } from "react-icons/md";
import { FiLinkedin } from "react-icons/fi";
import { Link } from "react-router-dom";
import { RiTwitterXFill } from "react-icons/ri";
import { RiInstagramFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleRequestInformation = () => {
    navigate("/Contact_Us");
  };
  return (
    <>
      <div className="footer-container">
        <div className="footer-subcontainer">
          <div className="footer-top-section">
            <div className="footer-top-section-content">
              <h2>Let's Stay in touch!</h2>
              <p>Join our mailing list to learn more about NICAS</p>
            </div>
            <div className="footer-top-button-container">
              <button className="button" onClick={handleRequestInformation}>
                Request Information
              </button>
            </div>
            <div className="footer-top-icons-container">
              <div className="footer-top-icons">
                <div>
                  <a href="https://www.facebook.com/rajalakshmi.saravana.714" target="_blank">
                    <FiFacebook className="footer-top-icons-style" />
                  </a>
                </div>
                <div>
                  <a style={{cursor:"default"}}>
                    <FiLinkedin className="footer-top-icons-style" />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.instagram.com/n_i_college_official?utm_source=qr&igsh=MTlpYWw4dTNmc3prZw=="
                    target="_blank"
                  >
                    <RiInstagramFill className="footer-top-icons-style" />
                  </a>
                </div>
                <div>
                  <a style={{cursor:"default"}}>
                    <RiTwitterXFill className="footer-top-icons-style" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="footer-middle-section">
            <ul className="footer-middle-content">
              <li className="footer-middle-list-container">
                <div className="footer-middlesection-icons-container">
                  <FaLocationDot className="footer-middlesection-icons" />
                </div>
                <div className="footer-middlesection-content">
                  <p className="middle-res-nomobile">Kumaracoil, Thuckalay</p>
                  <p className="middle-res-nomobile">Tamil Nadu 629180</p>
                  <p className="middle-res-mobile">
                    Kumaracoil,<br></br>Thuckalay,<br></br>Tamil Nadu 629180
                  </p>
                </div>
              </li>
              <li className="footer-middle-list-container">
                <div className="footer-middlesection-icons-container">
                  <IoCall className="footer-middlesection-icons" />
                </div>
                <div className="footer-middlesection-content">
                  <p>04651-253766</p>
                </div>
              </li>
              <li className="footer-middle-list-container">
                <div className="footer-middlesection-icons-container">
                  <MdMailOutline className="footer-middlesection-icons" />
                </div>
                <div className="footer-middlesection-content">
                  <p className="middle-res-nomobile">
                    nicollege2001@yahoo.co.in
                  </p>
                  <p className="middle-res-mobile">
                    nicollege2001<br></br>@yahoo.co.in
                  </p>
                </div>
              </li>
            </ul>

            <ul className="footer-middle-content">
              <li>
                <Link to="/aboutus/history">About NICAS</Link>
              </li>
              <li>
                <Link to="/Contact_Us">Contact Us</Link>
              </li>
              <li>
                <Link to="/Gallery">Gallery</Link>
              </li>
            </ul>

            <ul className="footer-middle-content">
              <li>
                <Link to="/academics/ug-programmes">UG Programmes</Link>
              </li>
              <li>
                <Link to="/academics/pg-programmes">PG Programmes</Link>
              </li>
              <li>
                <Link to="/Admission/Application_For_Admission">Admission</Link>
              </li>
              <li>
                <Link
                  onClick={() => window.open("/Admission/BrochureNICAS.pdf", "_blank")}
                >
                  Brochure
                </Link>
              </li>
              <li>
                <Link to="/academics/curriculum-and-syllabus">Syllabus</Link>
              </li>
            </ul>
            <ul className="footer-middle-content">
              <li>
                <Link to="/Campus_Life/Grievance_Redressal/Ombudsman">
                  Ombudsman
                </Link>
              </li>
              <li>
                <Link to="/Campus_Life/Scholarship/">Scholarship</Link>
              </li>
              <li>
                <Link to="/Login">Staff Login</Link>
              </li>
              <li>
                <Link to="/Helpdesk/Inquiry-Career">Career</Link>
              </li>
              <li>
                <Link to="/iqac/about">IQAC</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-section-container">
            <div className="footer-bottom-section">
              <img src={logoimg}></img>
            </div>
          </div>
          <div className="footer-bottom-copyright-container res-nomobile">
            <div className="footer-bottom-copyright">
              <Link href="/">
                copyright &copy; 2025 Noorul Islam College of Arts and Science. All rights
                reserved
              </Link>
              <ul className="footer-bottom-copyright-content">
                <li>
                  <Link>Privacy Policy</Link>
                </li>
                <li>
                  <Link> Terms & Condition</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="res-mobile">
            <Link href="/">
              copyright &copy; 2025 Noorul Islam College of Arts and Science. All rights
              reserved. Privacy Policy. Terms & Condition
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
